<template>
  <div class="not_height_datatable"
       style="display: flex; flex-direction: column; height: 100%">
    <ag-grid-vue style="width: 100%; height: 100%"
                 class="ag-theme-balham"
                 :gridOptions="gridOptions"
                 :columnDefs="columnDefs"

                 :defaultColDef="defaultColDef"
                 :rowData="rowData"
                 :rowHeight="rowHeight"
                 :animateRows="true"
                 @first-data-rendered="onFirstDataRendered"

                 @row-clicked="onRowClicked"

                 :frameworkComponents="frameworkComponents"
                 :loadingOverlayComponent="loadingOverlayComponent"
                 :loadingOverlayComponentParams="loadingOverlayComponentParams"
                 :noRowsOverlayComponent="noRowsOverlayComponent"
                 :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import OverlayLoading from "./overlay_loading";
import OverlayNoRows from "./overlay_no_rows";

import {mapActions} from 'vuex'

export default {
  name: "datatable_not_full_height",
  components: {
    AgGridVue,
    OverlayLoading,
    OverlayNoRows
  },
  props: {
    rowData: null,
    loadingMessage: {type: String, default: 'Loading...'},
    noRowsMessage: {type: String, default: 'No Rows Found'},
    columns: null,
    type: {type: String, required: true},
    recordType: {type: String, required: false},
  },

  data() {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowHeight: null,

      frameworkComponents: null,
      loadingOverlayComponent: null,
      loadingOverlayComponentParams: null,
      noRowsOverlayComponent: null,
      noRowsOverlayComponentParams: null,
    }
  },
  beforeMount() {
    this.gridOptions = {
      suppressCellSelection: true,
      pagination: true,
      paginationPageSize: 30,
      rowStyle: {
        'border-bottom': 'white 1px solid',
        'border-top': 'white 1px solid',
      },
      gridAutoHeight: true,
      onColumnResized: this.onColumnResized,
    };
    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: true,
      filterParams: {newRowsAction: 'keep', buttons: ['reset'],},
      cellStyle: {"white-space": "normal"},
      unSortIcon: true,
      suppressMenu: true,
      autoHeight: true,
      suppressSizeToFit: false,
      flex: 1,
      wrapText: true,     // <-- HERE
    };

    this.frameworkComponents = {
      customLoadingCellRenderer: OverlayLoading,
      customNoRowsOverlay: OverlayNoRows,
    };
    this.loadingOverlayComponent = 'customLoadingCellRenderer';
    this.loadingOverlayComponentParams = {loadingMessage: this.loadingMessage};
    this.noRowsOverlayComponent = 'customNoRowsOverlay';
    this.noRowsOverlayComponentParams = {noRowsMessage: this.noRowsMessage};

    this.columnDefs = this.columns;

    this.$bus.$on('table::reload', ($event) => {
      if ($event.table === 'all_workers' && $event.type === 'delete' && this.type === 'workers') {
        this.rowData.splice(this.$store.state.workers.current_row_id.row_id, 1);
      }
      if ($event.table === 'all_workers' && $event.type === 'update' && this.type === 'workers') {
        this.gridApi.refreshCells({force: true, rowNodes: [this.$store.state.workers.current_row_id.row_id]})
      }
      if ($event.table === 'all_workers' && $event.type === 'store' && this.type === 'workers') {
        this.gridApi.refreshCells({force: true})
      }

      if ($event.table === 'all_companies' && $event.type === 'delete' && this.type === 'companies') {
        this.rowData.splice(this.$store.state.companies.current_row_id.row_id, 1);
      }
      if ($event.table === 'all_companies' && $event.type === 'update' && this.type === 'companies') {
        this.gridApi.refreshCells({force: true, rowNodes: [this.$store.state.companies.current_row_id.row_id]})
      }

      if ($event.table === 'all_contacts' && $event.type === 'delete' && this.type === 'contacts') {
        this.rowData.splice(this.$store.state.contacts.current_row_id.row_id, 1);
      }
      if ($event.table === 'all_contacts' && $event.type === 'update' && this.type === 'contacts') {
        this.gridApi.refreshCells({force: true, rowNodes: [this.$store.state.contacts.current_row_id.row_id]})
      }

      if ($event.table === 'company_addresses' && $event.type === 'delete' && this.type === 'address') {
        this.rowData.splice(this.$store.state.addresses.current_row_id.row_id, 1);
      }
      if ($event.table === 'company_addresses' && $event.type === 'update' && this.type === 'address') {
        this.gridApi.refreshCells({force: true, rowNodes: [this.$store.state.addresses.current_row_id.row_id]})
      }
    });
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  methods: {
    ...mapActions(['showRightInfo']),

    onRowClicked(params) {
      if (!this.$store.state.auth.me.roles.includes('client_sub') && !this.$store.state.auth.me.roles.includes('client_auth')) {
        if (this.type !== 'notes') {
          if (this.type === 'address') {
            this.$store.commit('SHOW_VIEW_ADDRESS_MODAL', {
              id: params.data.id,
              type: params.data.address_type
            });
            this.$store.state.addresses.view_modal = true;
            this.$store.commit('SET_ADDRESS_ROW', {
              row_id: params.node.id
            });
            this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_address_modal'));
          }
          else if (this.type === 'contacts') {
            this.$store.commit('SHOW_VIEW_CONTACT_MODAL', {
              contact_id: params.data.id,
              company_id: params.data.company_id
            });
            this.$store.state.contacts.view_modal = true;
            this.$store.commit('SET_CONTACT_ROW_ID', {
              row_id: params.node.id
            });
            this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_contact_modal'));
          }
          else if (this.type === 'activity') {
            if (this.recordType === 'contact') {
              this.$store.commit('SHOW_VIEW_LOG_MODAL', {
                log_type: 'contact',
                id: params.data.id,
                log_by: params.data.user,
                log_by_id: params.data.log_by_id,
                new_values: params.data.new_values,
                old_note_by: params.data.old_note_by,
                old_values: params.data.old_values,
                type: params.data.type,
                updated_at: params.data.updated_at,
                contact_id: params.data.contact_id,
                contact_model_id: params.data.contact_model_id,
                contact_model_type: params.data.contact_model_type,
                client_id: params.data.client_id
              });
              this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_log_modal'))
            }
            if (this.recordType === 'worker') {
              this.$store.commit('SHOW_VIEW_LOG_MODAL', {
                log_type: 'worker',
                id: params.data.id,
                log_by: params.data.log_by,
                log_by_id: params.data.log_by_id,
                log_by_type: params.data.log_by_type,
                new_values: params.data.new_values,
                old_note_by: params.data.old_note_by,
                old_values: params.data.old_values,
                type: params.data.type,
                updated_at: params.data.updated_at,
                worker_id: params.data.worker_id,
                worker_model_id: params.data.worker_model_id,
                worker_model_type: params.data.worker_model_type,
              });
              this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_log_modal'))
            }
          }
          else {
            if (this.type === 'workers') {
              this.$store.commit('SET_WORKER_ROW_ID', {
                row_id: params.node.id
              });
            }
            if (this.type === 'companies') {
              this.$store.commit('SET_COMPANY_ROW_ID', {
                row_id: params.node.id
              });
            }
            this.$store.commit('CURRENT_RIGHT_INFO_TABLE_ROW', {
              node_id: params.node.id
            });
            this.showRightInfo({data: params.data, type: this.type});
          }
        }
        if (this.type === 'notes') {
          let name = null;
          if (this.recordType === 'worker') {
            name = params.data.worker.full_name;
          }
          if (this.recordType === 'contact') {
            name = params.data.contact.full_name;
          }
          this.$store.commit('SHOW_VIEW_NOTE_MODAL', {
            id: params.data.id,
            name: name,
            type: this.recordType,
            contacts: null
          });
          this.$store.state.notes.view_modal = true;
          this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_note_modal'));
        }
        this.$store.commit('CURRENT_RIGHT_INFO_TABLE_ROW', {
          node_id: params.node.id
        });
      }
    },

    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
      params.api.resetRowHeights();
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    saveFilterModel() {
    },
    restoreFilterModel() {
    }
  },
}
</script>
